import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="new-order-form"
export default class extends Controller {
  static targets = ["submitButton"];

  validate(e) {
    const campaignTitleValue = e.target.value;

    if (campaignTitleValue.trim() === "") {
      this.submitButtonTarget.disabled = true;
    } else {
      this.submitButtonTarget.disabled = false;
    }
  }
}
